import React, { useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDarkMode } from '../utils/DarkModeProvider';
import stylesTableDarkMode from '../styles/TableDarkMode'
import stylesTableLightMode from '../styles/TableLightMode'
import { useGlobal } from '../utils/GlobalContext';
import Modal from './Modal';
import Swal from 'sweetalert2'
import { useAuth } from '../pages/AuthContext';

export default function Instancias({ indice_completo }) {

    const { globalState, globalStateBorrarInstancia } = useGlobal()
    const { user } = useAuth();

    const { darkMode } = useDarkMode()

    const dynamicStyles = darkMode ? stylesTableDarkMode : stylesTableLightMode

    const [modalOpen, setModalOpen] = useState(null)

    const normalizarEstado = (estado) => {
        const estadoCrudo = typeof estado === 'string' ? estado : estado?.estado
        return String(estadoCrudo || '').trim().toLowerCase()
    }

    const ESTADOS_EDITABLES_DOCENTE = new Set([
        'creado_por_docente',
        'modificado_por_docente',
        'borrado_por_docente',
        'confirmado_por_docente'
    ])

    const esConfirmado = (estado) => {
        const estadoNormalizado = normalizarEstado(estado)
        return estadoNormalizado === 'confirmado_por_docente' || estadoNormalizado === 'confirmado'
    }

    const esConfirmadoAdmin = (estado) => {
        const estadoNormalizado = normalizarEstado(estado)
        return estadoNormalizado === 'confirmado_admin' || estadoNormalizado.endsWith('_por_admin')
    }

    const esAdmin = user?.rol === 'Admin'
    const esDocente = user?.rol === 'Docente'

    const puedeEditarOBorrar = (estado) => {
        if (esAdmin) return true
        if (!esDocente) return false
        return ESTADOS_EDITABLES_DOCENTE.has(normalizarEstado(estado))
    }

    const editarInstancia = (instanciaId) => {
        setModalOpen(instanciaId)
    }

    const borrarInstancia = (instancia) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción borrará el elemento seleccionado.',
            icon: 'warning',
            showCancelButton: true,
            background: darkMode ? '#1e1e1e' : '#fff',
            color: darkMode ? '#fff' : '#545454',
            confirmButtonColor: darkMode ? '#66BB6A' : '#4CAF50',
            cancelButtonColor: darkMode ? '#e57373' : '#d9534f',
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                globalStateBorrarInstancia(indice_completo, instancia)
            }
        })
    }

    const normalizarHref = (valor) => {
        if (typeof valor !== 'string') return ''
        const limpio = valor.trim()
        if (!limpio) return ''
        if (/^https?:\/\//i.test(limpio)) return limpio
        return `https://${limpio}`
    }

    return (
        globalState && globalState.items.map((item, itemIndex) => {
            return (
                indice_completo === item.indice_completo &&
                item.instancias.map((instanciaAtributo, rowIndex) => {
                    const puedeEditar = puedeEditarOBorrar(instanciaAtributo.estado)

                    return (
                        <React.Fragment key={rowIndex}>
                            <tr
                                key={rowIndex}
                                style={{
                                    ...(rowIndex % 2 === 0 ? dynamicStyles.evenRow : dynamicStyles.oddRow),
                                    ...(esConfirmado(instanciaAtributo.estado) && {
                                        backgroundColor: darkMode ? 'rgba(76, 175, 80, 0.15)' : '#e8f5e9',
                                    }),
                                    ...(esConfirmadoAdmin(instanciaAtributo.estado) && {
                                        backgroundColor: darkMode ? 'rgba(2, 136, 209, 0.18)' : '#e3f2fd',
                                    }),
                                    transition: 'all 0.2s ease-in-out'
                                }}
                            >
                                {instanciaAtributo.valores.map((i, cellIndex) => (
                                    <td
                                        key={cellIndex}
                                        style={{
                                            ...dynamicStyles.cell,
                                            minWidth: 120,
                                            maxWidth: 240,
                                            paddingTop: 6,
                                            paddingBottom: 6,
                                            fontSize: 12,
                                            lineHeight: 1.2,
                                            whiteSpace: 'pre-wrap',
                                            wordBreak: 'break-word',
                                            overflowWrap: 'anywhere',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        {i.tipo === 'link' && normalizarHref(i.valor)
                                            ? (
                                                <a
                                                    href={normalizarHref(i.valor)}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title={i.valor}
                                                >
                                                    {i.valor}
                                                </a>
                                            )
                                            : i.valor}
                                    </td>
                                ))}
                                <td
                                    style={{
                                        ...dynamicStyles.cell,
                                        minWidth: 84,
                                        maxWidth: 84,
                                        paddingTop: 6,
                                        paddingBottom: 6,
                                        textAlign: 'center',
                                        verticalAlign: 'middle',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    <div style={styles.buttonContainer}>
                                        <button
                                            style={{
                                                ...styles.button,
                                                ...styles.editButton,
                                                ...(!puedeEditar ? styles.disabledButton : {})
                                            }}
                                            title="Editar"
                                            aria-label="Editar"
                                            disabled={!puedeEditar}
                                            onMouseEnter={(e) => {
                                                if (puedeEditar) e.target.style.backgroundColor = styles.editButtonHover.backgroundColor
                                            }}
                                            onMouseLeave={(e) => {
                                                if (puedeEditar) e.target.style.backgroundColor = styles.editButton.backgroundColor
                                            }}
                                            onClick={() => puedeEditar && editarInstancia(instanciaAtributo.id)}
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            style={{
                                                ...styles.button,
                                                ...styles.deleteButton,
                                                ...(!puedeEditar ? styles.disabledButton : {})
                                            }}
                                            title="Borrar"
                                            aria-label="Borrar"
                                            disabled={!puedeEditar}
                                            onMouseEnter={(e) => {
                                                if (puedeEditar) e.target.style.backgroundColor = styles.deleteButtonHover.backgroundColor
                                            }}
                                            onMouseLeave={(e) => {
                                                if (puedeEditar) e.target.style.backgroundColor = styles.deleteButton.backgroundColor
                                            }}
                                            onClick={() => puedeEditar && borrarInstancia(instanciaAtributo)}
                                        >
                                            🗑️
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <Modal
                                elem={item}
                                isOpen={modalOpen === instanciaAtributo.id}
                                closeModal={() => setModalOpen(null)}
                                esEdicion={true}
                                index={rowIndex}
                                idActualizar={instanciaAtributo.id}
                            />
                        </React.Fragment>
                    )
                })
            )
        })
    )
}

const styles = {
    buttonContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        gap: '10px',
        padding: '0 2px',
        flexWrap: 'nowrap'
    },
    button: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        height: 24,
        padding: 0,
        border: 'none',
        cursor: 'pointer',
        borderRadius: 4,
        fontSize: 12,
        lineHeight: 1,
        transition: 'all 0.3s ease-in-out',
        boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.16)',
        margin: 0
    },
    disabledButton: {
        opacity: 0.4,
        filter: 'grayscale(0.35)',
        cursor: 'not-allowed',
        boxShadow: 'none'
    },
    editButton: {
        backgroundColor: '#007bff',
        color: 'white',
    },
    editButtonHover: {
        backgroundColor: '#0056b3',
    },
    deleteButton: {
        backgroundColor: '#dc3545',
        color: 'white',
    },
    deleteButtonHover: {
        backgroundColor: '#a71d2a',
    },
};